export function initSentry() {
    const dsn = window.__SENTRY_DSN__;
    if (!dsn)
        return;
    import("@sentry/browser").then((Sentry) => {
        Sentry.init({ dsn, tracesSampleRate: 0.1, environment: window.__ENV__ ?? "staging" });
    });
}
